import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { onBvShowReviews } from 'hooks/useBazaarVoice';

// Subscribes to BV.swat_reviews 'show' (star / "Read X reviews" clicks) and
// force-mounts the reviews widget synchronously so BV can attach shadowRoot.
const useBvReviewsForceMount = () => {
  const $ = _c(2);
  const [forceMountReviews, setForceMountReviews] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => onBvShowReviews(() => {
      flushSync(() => {
        setForceMountReviews(true);
      });
    });
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return forceMountReviews;
};
export default useBvReviewsForceMount;